import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import { rel } from '../../../../../../utils/rel';
import styles from './index.css';

const RecPicList = errorBoundary(
    class extends PureComponent {
        static propTypes = {
            content: PropTypes.array,
        };

        render() {
            const { content } = this.props;

            const recPicList = content.map((item, index) => (
                <div
                    className={`${index === 0 ? styles.col_d_box1 : styles.col_d_box2} ${
                        index === 1 ? styles.noMarginLeft : null
                    }`}
                    key={index}>
                    <a href={item.url} target="_blank" rel={rel}>
                        <img src={item.thumbnail} alt={item.title} />
                        <div className={styles.tm_bg} />
                        <div className={styles.text_word}>{item.title}</div>
                    </a>
                </div>
            ));

            return <div className={styles.recBox}>{recPicList}</div>;
        }
    },
);

export { RecPicList };
export default RecPicList;
